const getCountUpTimeFormatter = (duration) => {
  if (duration <= 0) return '00:00:00';

  const absSeconds = Math.abs(duration);

  const hours = String(Math.floor(absSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((absSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(absSeconds % 60).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};

export default getCountUpTimeFormatter;
